import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {TranslateDirective, TranslatePipe, TranslateService} from "@ngx-translate/core";
import {AutoComplete} from "primeng/autocomplete";
import {KeyValuePipe, NgForOf, NgIf} from "@angular/common";
import {
  EditAccessoryValueForm
} from "../../../odm-accessories-management/odm-edit-accessory-value-modal/odm-edit-accessory-value-modal.component";
import {TranslationService} from "../../../../shared";
import {User} from "../../../../../shared/user/user";
import {SessionStorage} from "ngx-webstorage";
import {
  EditAccessoryForm
} from "../../../odm-accessories-management/odm-edit-accessory-modal/odm-edit-accessory-modal.component";
import {Category} from "../../../../../configuration/shared/model/IProduct";

export type EditCategoryForm = {
  categoryId: string;
  value: {
    [key: string]: string;
  };
}

@Component({
  selector: 'app-odm-option-select-category',
  imports: [
    FormsModule,
    TranslateDirective,
    AutoComplete,
    TranslatePipe,
    KeyValuePipe,
    NgForOf,
    NgIf
  ],
  templateUrl: './odm-option-select-category.component.html',
  styleUrl: './odm-option-select-category.component.scss'
})
export class OdmOptionSelectCategoryComponent implements OnChanges {
  @SessionStorage()
  public user: User;

  public hasNoCategory: boolean;

  public currentCategory: string

  public filteredCategories: string[] = [];

  public categoryValueForm: EditCategoryForm = {categoryId: null, value: {}};

  public languages: string[] = [];

  @Input()
  public exitingCategories: Category[] = [];
  @Output()
  eventCategory: EventEmitter<EditCategoryForm> = new EventEmitter<EditCategoryForm>();

  constructor(private readonly translationService: TranslationService,
              private readonly translateService: TranslateService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.resetSelection();
  }

  filterCategoryReference(event: any): void {
    const query = event.query.trim().toLowerCase();
    this.filteredCategories = this.exitingCategories
      .map(category => category.id)
      .filter(category => category && category.toLowerCase().includes(query));
  }

  onChangesCategoryEnable(){
    if(this.hasNoCategory){
      this.categoryValueForm.categoryId = null;
      this.eventCategory.emit(this.categoryValueForm);
    } else {
      this.eventCategory.emit(null);
    }
  }

  onChangesCategoryField(event: any): void {
    this.currentCategory = event.toString().trim();
    this.categoryValueForm.categoryId = this.currentCategory;
    let missingTranslations = false;
    this.languages.forEach(lang => {
      missingTranslations = missingTranslations || !this.categoryValueForm.value[lang];
    });
    if (this.isExistingCategory()) {
      this.getCategoryTranslation();
    }else if (this.categoryValueForm.categoryId.length === 0 || missingTranslations) {
      this.eventCategory.emit(null);
    } else {
      this.eventCategory.emit(this.categoryValueForm);
    }
  }

  public isExistingCategory(): boolean {
    return this.currentCategory && this.exitingCategories.filter(category => category.id === this.currentCategory).length === 1;
  }

  public showCategory(): boolean {
    return !this.hasNoCategory;
  }

  public getCategoryTranslation(){
    const categories = this.exitingCategories.filter(category => category.id === this.currentCategory);
    if (!categories.length) {
      return;
    }
    this.translationService.getLocalesOfCountryOfKey(categories[0].name).subscribe((locale => {
      locale.forEach(loc => {
        this.categoryValueForm.value[loc.language] = loc.translations[0].translation;
      });
      this.eventCategory.emit(this.categoryValueForm);
    }));
  }

  private resetSelection() {
    this.hasNoCategory = false;
    this.currentCategory = '';
    this.categoryValueForm = {categoryId: null, value: {}};
    this.translationService.getAllLanguagesByCountry(this.user.partnerCountry).subscribe(languages => {
      this.languages = languages;
      languages.forEach(lang => {
        this.categoryValueForm.value[lang] = '';
      })
    });
  }

  trackByFn(index: number): number {
    return index;
  }

}